import clsx from 'clsx';
import React, { useMemo, useState } from 'react';
import { getMonthNames } from '../../utils/date/getMonthNames';
import { Button } from '../Button';
import { useDescendant, useDescendantsContext } from '../Descandants';
import { DatePickerDescendantsContext } from './DatePicker';
export function DatePickerCell(props) {
    const { period, date, locale, disabled, currentDate, onClick, onFocus, onMouseOver, onMouseLeave, } = props;
    const [element, setElement] = useState(null);
    const descendant = useMemo(() => ({ element, date }), [element, date]);
    const index = useDescendant(descendant, DatePickerDescendantsContext, undefined, disabled);
    const { activeIndex, setActiveIndex } = useDescendantsContext(DatePickerDescendantsContext);
    const active = index === activeIndex;
    const selected = period === 'month'
        ? currentDate.getMonth() === date.getMonth()
        : currentDate.getFullYear() === date.getFullYear();
    return (React.createElement("td", { className: "mollie-ui-date-picker-cell", key: date.toISOString(), role: "gridcell", "aria-disabled": disabled, "aria-selected": selected },
        React.createElement(Button, { unstyled: true, className: clsx('mollie-ui-date-picker-cell-button', {
                'mollie-ui-date-picker-cell-button--all-selected': selected,
            }), disabled: disabled, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(date), onFocus: () => {
                onFocus === null || onFocus === void 0 ? void 0 : onFocus(date);
                setActiveIndex(index);
            }, 
            /*
             * use onMouseOver instead of onMouseEnter because of a bug in React where onMouseEnter is not triggered when the related target is disabled
             * @see https://github.com/facebook/react/issues/10109
             */
            onMouseOver: () => {
                if (!disabled)
                    onMouseOver === null || onMouseOver === void 0 ? void 0 : onMouseOver(date);
            }, onMouseLeave: () => {
                if (!disabled)
                    onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(date);
            }, tabIndex: active ? 0 : -1, ref: setElement }, period === 'year'
            ? date.getFullYear()
            : getMonthNames(locale)[date.getMonth()])));
}
//# sourceMappingURL=DatePickerCalendarCell.js.map